module.exports = __webpack_public_path__ + "static/media/YantroMitra.7378b944.webp";